// extracted by mini-css-extract-plugin
export default {"summary":"jA","separator":"kA","title":"lA","note":"mA","items_wrapper":"nA","member_perk":"oA","info":"pA"};
    if(module.hot) {
      // 1715188235914
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  